import { render, staticRenderFns } from "./AdminReservationsPage.vue?vue&type=template&id=0029a476&"
import script from "./AdminReservationsPage.vue?vue&type=script&lang=js&"
export * from "./AdminReservationsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports